import React from 'react';
import './ProductSearchlightModeToggle.css';

export type ProductSearchlightMode = 'chat' | 'collaborator';

interface ProductSearchlightModeToggleProps {
  mode: ProductSearchlightMode;
  onChange: (mode: ProductSearchlightMode) => void;
}

const ProductSearchlightModeToggle: React.FC<ProductSearchlightModeToggleProps> = ({
  mode,
  onChange,
}) => (
  <div className="ps-mode-toggle" role="tablist" aria-label="Product Searchlight mode">
    <button
      type="button"
      role="tab"
      aria-selected={mode === 'chat'}
      className={`ps-mode-toggle__btn ${mode === 'chat' ? 'ps-mode-toggle__btn--active' : ''}`}
      onClick={() => onChange('chat')}
    >
      Chat
    </button>
    <button
      type="button"
      role="tab"
      aria-selected={mode === 'collaborator'}
      className={`ps-mode-toggle__btn ${mode === 'collaborator' ? 'ps-mode-toggle__btn--active' : ''}`}
      onClick={() => onChange('collaborator')}
    >
      Collaborator
    </button>
  </div>
);

export default ProductSearchlightModeToggle;
